import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core'
import { IStructure } from '../model/structure.model';
import { AdherentService } from '../service/adherent.service';
import {
    CampAdherentStaffRoleEnum,
    CampAdherentType, CompositionTypeEnum,
    TypeAdherentEnum,
    TypeCampEnum,
    TypeCampGroupEnum,
    TypeDossierEnum,
} from '../constant/enum'
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Adherent, IAdherent } from '../model/adherent.model';
import { MatSort } from '@angular/material/sort';
import { convertToHumanDate, getAgeAdherentAuDebutCamp } from '../util/moment.utils';
import { checkCodeEntry, checkDates, disableCodeSubmitButton } from '../util/form-validator.utils';
import { IAdherentFormation, IAdherentInformations } from '../model/adherent-informations.model';
import { filterOkMapBody } from '../util/http.utils';
import { ICamp } from '../model/camp.model';
import { IProjetAnnee } from '../model/projet-annee.model';
import { CampAdherentStaff, ICampAdherentStaff } from '../model/camp-adherent-staff.model';
import { IProjetAnneeAdherentStaff, ProjetAnneeAdherentStaff } from '../model/projet-annee-adherent-staff.model';
import { HandlableError } from '../interceptor/error-handler.interceptor';
import { SnackBarService } from '../service/snackbar.service';
import {
  DDC_ADHERENT_STAFF_RESPONSIBILITIES,
  DDC_ADHERENT_STAFF_ROLES,
  DDC_ADHERENT_STAFF_STAGES
} from '../constant/constant';
import { getAdherentQualificationLabel, getDdcAdherentStaffRoleIcon } from '../util/adherent-utils'

@Component({
    selector: 'ddc-staff-selector',
    templateUrl: './staff-selector-component.html',
    styleUrls: ['./staff-selector-component.scss'],
    standalone: false
})
export class StaffSelectorComponent implements OnChanges {

  @Input() set staffsFormArray(staffsFormArray: FormArray) {
      if (staffsFormArray) {
          this._staffsFormArray = staffsFormArray;
          this.initiateComponent();
      }
  }

  @Input() set ddcStructures(ddcStructures: IStructure[]) {
    this._ddcStructures = ddcStructures;
  }

  @Input() set typeDossier(typeDossier: TypeDossierEnum) {
      this._typeDossier = typeDossier;
      this.structureDependanteCheckboxBool = typeDossier === TypeDossierEnum.PROJET_ANNEE;
      this.displayStructureDependanteCheckbox();
      this.initiateComponent();
  }

  @Input() set ddcDefaultStructure(ddcDefaultStructure: IStructure) {
    this._ddcDefaultStructure = ddcDefaultStructure;
    this.structureSelected = ddcDefaultStructure;
  }

  @Input() set isSaving(isSaving: boolean) {
    this._isSaving = isSaving;
  }

  @Input() set currentCamp(currentCamp: ICamp) {
    this._currentCamp = currentCamp;
    this.initiateComponent();
  }

  @Input() set campFormPatchValue(campFormPatchValue: ICamp) {
    this._campFormPatchValue = campFormPatchValue;
  }

  @Input() set projetAnneeFormPatchValue(projetAnneeFormPatchValue: IProjetAnnee) {
    this._projetAnneeFormPatchValue = projetAnneeFormPatchValue;
  }

  @Input() set currentProjetAnnee(currentProjetAnnee: IProjetAnnee) {
    this._currentProjetAnnee = currentProjetAnnee;
    this.initiateComponent();
  }

  @Input() set compositionType(compositionType: CompositionTypeEnum) {
    this._compositionType = compositionType;
    this.initiateComponent();
  }
  
  @Input() refreshAdherentOptionsCount: number;
  
  @Output() doUpdateAdherentsOptions = new EventEmitter();

  _staffsFormArray: FormArray;
  _ddcStructures: IStructure[];
  _ddcDefaultStructure: IStructure;
  _typeDossier: TypeDossierEnum;
  _currentCamp: ICamp;
  _campFormPatchValue: ICamp;
  _currentProjetAnnee: IProjetAnnee;
  _projetAnneeFormPatchValue: IProjetAnnee;
  _compositionType: CompositionTypeEnum;

  _isSaving: boolean;

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  TypeCampGroupEnum = TypeCampGroupEnum;
  TypeCampEnum = TypeCampEnum;
  CompositionTypeEnum = CompositionTypeEnum;

  allAdherentsDisponibles: IAdherent[] = [];

  ddcStaffsTableDataSource = new MatTableDataSource<AbstractControl>([]);
  campStaffsTableDisplayedColumns = ['role', 'prenomNom', 'agePremierJourCamp', 'qualif', 'techAppro', 'stage', 'resp', 'dateDebutPresence', 'dateFinPresence', 'supprimer'];
  campAudaceStaffsTableDisplayedColumns = ['role', 'prenomNom', 'agePremierJourCamp', 'qualif', 'techAppro', 'resp', 'dateDebutPresence', 'dateFinPresence', 'supprimer'];
  campFarfadetStaffsTableDisplayedColumns = ['role', 'prenomNom', 'agePremierJourCamp', 'qualif', 'resp', 'dateDebutPresence', 'dateFinPresence', 'supprimer'];
  projetAnneeStaffsTableDisplayedColumns = ['role', 'prenomNom', 'qualif', 'techAppro', 'stage', 'supprimer'];


  adherentsDisponiblesTableDataSource = new MatTableDataSource<IAdherent>([]);
  adherentsDisponiblesTableDisplayedColumns = ['prenomNom', 'ajouter'];

  adherentsInformations: IAdherentInformations[] = [];

  adherentFormationsTableDisplayedComumns = ['type', 'dateFin'];
  adherentDiplomesTableDisplayedComumns = ['type', 'dateObtention'];
  adherentQualificationsTableDisplayedComumns = ['type', 'estTitulaire', 'dateFin'];

  ddcStaffSelectionneFormGroup: FormGroup;

  codeEntryForm: FormGroup = this.fb.group({
    staff: ['', [checkCodeEntry]],
  });

  ddcAdherentStaffResponsibilities = DDC_ADHERENT_STAFF_RESPONSIBILITIES;
  ddcAdherentStaffStages = DDC_ADHERENT_STAFF_STAGES;
  ddcAdherentStaffRoles = DDC_ADHERENT_STAFF_ROLES;

  getAgeAdherentAuDebutCamp = getAgeAdherentAuDebutCamp;
  convertToHumanDate = convertToHumanDate;
  disableCodeSubmitButton = disableCodeSubmitButton;
  TypeDossierEnum = TypeDossierEnum;
  TypeAdherentEnum = TypeAdherentEnum;
  numeroAdherentSelectionne: number;
  warningMessageDirecteur: string = '';
  structureDependanteCheckboxBool: boolean = false;
  isStructureDependanteCheckbox: boolean;
  structureSelected;

  getAdherentQualificationLabel  = getAdherentQualificationLabel;
  getDdcAdherentStaffRoleIcon = getDdcAdherentStaffRoleIcon;

  constructor(
    protected adherentService: AdherentService,
    protected snackBarService: SnackBarService,
    protected fb: FormBuilder
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes.refreshAdherentOptionsCount?.firstChange) {
          return;
      }
      if (changes.refreshAdherentOptionsCount) {
          this.refreshAdherentsDisponiblesOptions();
          return;
      }
      this.initiateComponent();
  }

  initiateComponent() {
      if (this.getStaffsFormArray() && this._typeDossier && (this._currentCamp || this._currentProjetAnnee) && this._compositionType){
          this.getAdherentsByStructure(this.structureSelected , this._typeDossier === TypeDossierEnum.PROJET_ANNEE);
          this.initAdherentsDisponiblesTableData();
          this.initDdcStaffsTableData(this.getStaffsFormArray());
          this.initAdherentsInformations(this.getStaffsFormArray());
          this.getStaffsFormArray().valueChanges.subscribe(campAdherentStaff => {
              this.checkDdcAdherentStaffDirector(campAdherentStaff);
          });
          this.allAdherentsDisponibles = this._staffsFormArray.getRawValue().map((staff: ICampAdherentStaff | IProjetAnneeAdherentStaff) => staff.adherent);
          this.ddcStaffSelectionneFormGroup = null;
      }
  }

  private initAdherentsDisponiblesTableData() {
    const ddcAdherentStaffsNumeros = new Set<string>(this.getStaffsFormArray()?.getRawValue().map(ddcAdherentStaff => ddcAdherentStaff.adherent.numero));
    if(!!this.allAdherentsDisponibles && this.allAdherentsDisponibles.length > 0){
      this.adherentsDisponiblesTableDataSource.data = this.allAdherentsDisponibles.filter(adherent => !ddcAdherentStaffsNumeros.has(adherent?.numero));
    }
  }

  private initDdcStaffsTableData(staffsFormArray: FormArray) {
    this.ddcStaffsTableDataSource.data = staffsFormArray
                                         ? staffsFormArray.controls
                                                          .filter(control =>
                                                                      control.get('compositionType')
                                                                          ?.value === this._compositionType)
                                         : [];
  }

  private getStaffsFormArray(): FormArray {
    return this._staffsFormArray as FormArray;
  }

  getAdherentsByStructure(structure: IStructure, structureDepandant: boolean = false) {
    if (structure !== null) {
      const allAdherentsDisponiblePromise: Promise<IAdherent[]> =
        this.adherentService.findByCodeStructure(structure.code, CampAdherentType.STAFF, structureDepandant)
          .pipe(filterOkMapBody)
          .toPromise();

      const staffs = this._staffsFormArray?.getRawValue() ?? [];
      allAdherentsDisponiblePromise.then((adherents: IAdherent[]) => {
        this.allAdherentsDisponibles = adherents;
        const ddcAdherentStaffsCodes = new Set<string>(adherents.map((ddcAdherentStaff: IAdherent) => ddcAdherentStaff.numero));

        this.allAdherentsDisponibles.push(
          ...staffs
              .filter((staff: ICampAdherentStaff | IProjetAnneeAdherentStaff) => !ddcAdherentStaffsCodes.has(staff.adherent.numero))
              .map((staff: ICampAdherentStaff | IProjetAnneeAdherentStaff) => staff.adherent)
        );

        this.initAdherentsDisponiblesTableData();
      });
    }
  }

  private createCampAdherentStaffFormGroup(campAdherentStaff) {
    const formGroup = this.fb.group(new CampAdherentStaff());
    formGroup.controls.dateDebutPresence.setValidators(Validators.required);
    formGroup.controls.dateFinPresence.setValidators(Validators.required);
    formGroup.controls.roleStaff.setValidators(Validators.required);
    formGroup.setValidators(checkDates('dateDebutPresence', 'dateFinPresence', [this._currentCamp.dateDebut, this._currentCamp.dateFin], 'Choisissez une date qui appartient à la date du camp'));
    formGroup.patchValue(campAdherentStaff);
    if (campAdherentStaff.compositionType === CompositionTypeEnum.VISITEUR) {
        formGroup.controls.roleStaff.setValue(CampAdherentStaffRoleEnum.AUTRE);
        formGroup.controls.roleStaff.disable();
    }
    return formGroup;
  }

  private createProjetAnneeAdherentStaffFormGroup(projetAnneeAdherentStaff) {
    const formGroup = this.fb.group(new ProjetAnneeAdherentStaff());
    formGroup.controls.roleStaff.setValidators(Validators.required);
    formGroup.patchValue(projetAnneeAdherentStaff);
    if (projetAnneeAdherentStaff.compositionType === CompositionTypeEnum.VISITEUR) {
        formGroup.controls.roleStaff.setValue(CampAdherentStaffRoleEnum.AUTRE);
        formGroup.controls.roleStaff.disable();
    }
    return formGroup;
  }

  initAdherentsInformations(staffsFormArray: FormArray) {

    const adherents: IAdherent[] = staffsFormArray.getRawValue().map((staff: ICampAdherentStaff|IProjetAnneeAdherentStaff) => staff.adherent);

    let codesAdherent: string[] = [];
    let idCamp: number;

    // Retreive the information of the adherents
    let ddcStaffAdherentsInformations: IAdherentInformations[] = [];
    if (this._typeDossier === TypeDossierEnum.CAMP && this._currentCamp && this._currentCamp.campAdherentStaffsInformations) {
      ddcStaffAdherentsInformations = this._currentCamp.campAdherentStaffsInformations;
    }else if(this._typeDossier === TypeDossierEnum.PROJET_ANNEE && this._currentProjetAnnee && this._currentProjetAnnee.projetAnneeAdherentStaffsInformations) {
      ddcStaffAdherentsInformations = this._currentProjetAnnee.projetAnneeAdherentStaffsInformations;
    }

    if(ddcStaffAdherentsInformations && ddcStaffAdherentsInformations.length > 0) {
      ddcStaffAdherentsInformations.forEach((ddcStaffAdherentInformations: IAdherentInformations) => {
        this.adherentsInformations[ddcStaffAdherentInformations.numero] = ddcStaffAdherentInformations;
      });
    }

    // Check missing adherent informations (The ones who are not saved in database, but in localstorage 'cache')
    if(adherents && adherents.length > 0) {
      adherents.forEach((adherent: IAdherent) => {
        if(!this.adherentsInformations[adherent.numero]) {
          codesAdherent.push(adherent.numero)
        }
      });
      if(codesAdherent && codesAdherent.length > 0) {
        idCamp = this._typeDossier === TypeDossierEnum.CAMP ? this._currentCamp.id : null;
        this.adherentService.getAdherentsInformations(codesAdherent, this._typeDossier, idCamp)
          .pipe(filterOkMapBody)
          .subscribe((adherentsInformations: IAdherentInformations[]) => {
            if(adherentsInformations && adherentsInformations.length > 0) {
              adherentsInformations.forEach((adherentInformations: IAdherentInformations) => {
                this.adherentsInformations[adherentInformations.numero] = adherentInformations;
              });
            }
          });
      }
    }
  }

  setAdherentInformations(adherent: Adherent) {
    if(adherent && adherent.numero && !this.adherentsInformations[adherent.numero]) {
      const idCamp = this._typeDossier === TypeDossierEnum.CAMP ? this._currentCamp.id : null;
      this.adherentService.getAdherentInformations(adherent.numero, this._typeDossier, idCamp)
        .pipe(filterOkMapBody)
        .subscribe((adherentInformation: IAdherentInformations) => {
          this.adherentsInformations[adherent.numero] = adherentInformation;
          // this.initDdcStaffsTableData(staffFormArray);
        });
    }
  }

  getTechApproLabel(numero: number) {
    if (numero && this.adherentsInformations[numero] && this.adherentsInformations[numero].adherentFormations) {
      const adherentFormations = this.adherentsInformations[numero].adherentFormations;
      const regExpAppro = new RegExp('^appro', 'gi');
      const adherentFormationsAppro = adherentFormations.filter((adherentFormation: IAdherentFormation) => adherentFormation.type.match(regExpAppro));
      if (adherentFormationsAppro && adherentFormationsAppro.length > 0) {
        return 'APPRO';
      }
      const regExpTech = new RegExp('^tech', 'gi');
      const adherentFormationsTech = adherentFormations.filter((adherentFormation: IAdherentFormation) => adherentFormation.type.match(regExpTech));
      if (adherentFormationsTech && adherentFormationsTech.length > 0) {
        return 'TECH';
      }
    }
    return '';
  }

  changeSelectedStructure(event) {
    const structure: IStructure = event && event.value ? event.value : null;
    this.structureSelected = structure;
    this.displayStructureDependanteCheckbox();
    if(this.structureDependanteCheckboxBool == true){
      this.structureDependanteCheckbox(false)
    }
    this.getAdherentsByStructure(structure);
  }

  ajouterAdherentsDisponiblesSelectionnes(index: number) {
    const adherent = this.adherentsDisponiblesTableDataSource.data[index];
    const ddcAdherentStaffsCodes = new Set<string>(this.getStaffsFormArray().getRawValue().map((ddcAdherentStaff: ICampAdherentStaff|IProjetAnneeAdherentStaff) => ddcAdherentStaff.adherent.numero));
    const presenceFlag = ddcAdherentStaffsCodes.has(adherent.numero);
    if(!presenceFlag) {
      this.createDdcAherentStaff(adherent);
    }else {
      this.snackBarService.showError("L\'adhérent est déjà ajouté");
    }
  }

  addStaffByCodeEntry(adherentType: string) {
    const codeAdherent = this.codeEntryForm.get('staff').value;
    this.adherentService.findByNumero(codeAdherent, adherentType)
      .pipe(filterOkMapBody)
      .subscribe((adherent: IAdherent) => {
          if (adherent) {
            const ddcAdherentStaffsCodes = new Set<string>(this.getStaffsFormArray().getRawValue().map((ddcAdherentStaff: ICampAdherentStaff|IProjetAnneeAdherentStaff) => ddcAdherentStaff.adherent.numero));
            const presenceFlag = ddcAdherentStaffsCodes.has(adherent.numero);
            if (!presenceFlag) {
              this.createDdcAherentStaff(adherent);
            } else {
              this.codeEntryForm.get('staff').setErrors({errorMessage: 'L\'adhérent est déjà ajouté'});
            }
          } else {
            this.codeEntryForm.get('staff').setErrors({errorMessage: 'Le code adherent que vous avez saisi est inconnu'});
          }
        },
        (err: HandlableError) => {
          if (err && err.error.status === 404) {
            this.codeEntryForm.get('staff').setErrors({errorMessage: 'Le code adherent que vous avez saisi est inconnu'});
            err.markAsHandled();
          }
        });
  }

  createDdcAherentStaff(adherent: IAdherent) {
    const staffsFormArray = this.getStaffsFormArray();

    if(this._typeDossier === TypeDossierEnum.CAMP) {
      const ddcAdherentStaff = new CampAdherentStaff();
      ddcAdherentStaff.adherent = adherent;
      ddcAdherentStaff.id = 0;
      ddcAdherentStaff.roleStaff = this._compositionType === CompositionTypeEnum.VISITEUR
                                   ? CampAdherentStaffRoleEnum.AUTRE
                                   : CampAdherentStaffRoleEnum.CHEF;
      ddcAdherentStaff.validationStagePratiqueBafa = false;
      ddcAdherentStaff.validationStagePratiqueBafd = false;
      ddcAdherentStaff.responsabiliteIntendant = false;
      ddcAdherentStaff.responsabiliteTresorier = false;
      ddcAdherentStaff.responsabiliteAS = false;
      ddcAdherentStaff.responsabiliteMateriel = false;
      ddcAdherentStaff.responsabiliteAutre = this._compositionType === CompositionTypeEnum.VISITEUR;
      ddcAdherentStaff.dateDebutPresence = this._currentCamp.dateDebut;
      ddcAdherentStaff.dateFinPresence = this._currentCamp.dateFin;
      ddcAdherentStaff.compositionType = this._compositionType;
      staffsFormArray.push(this.createCampAdherentStaffFormGroup(ddcAdherentStaff));
    }else if(this._typeDossier === TypeDossierEnum.PROJET_ANNEE) {
      const ddcAdherentStaff = new ProjetAnneeAdherentStaff();
      ddcAdherentStaff.adherent = adherent;
      ddcAdherentStaff.id = 0;
      ddcAdherentStaff.roleStaff = this._compositionType === CompositionTypeEnum.VISITEUR
                                   ? CampAdherentStaffRoleEnum.AUTRE
                                   : CampAdherentStaffRoleEnum.CHEF;
      ddcAdherentStaff.validationStagePratiqueBafa = false;
      ddcAdherentStaff.validationStagePratiqueBafd = false;
      ddcAdherentStaff.compositionType = this._compositionType;
      staffsFormArray.push(this.createProjetAnneeAdherentStaffFormGroup(ddcAdherentStaff));
    }
    // On ré-initialise la liste des adhérents disponibles
    this.setAdherentInformations(adherent);
    this.initAdherentsDisponiblesTableData();
    this.initDdcStaffsTableData(staffsFormArray);
    this.doUpdateAdherentsOptions.emit(this._compositionType);
  }

  checkDdcAdherentStaffDirector(campAdherentStaff: []) {
    const directors = [];
    if (campAdherentStaff && campAdherentStaff.length > 0) {
      campAdherentStaff.forEach((campAdherentStaff: ICampAdherentStaff) => {
        if (campAdherentStaff.roleStaff === CampAdherentStaffRoleEnum.DIRECTEUR) {
          directors.push(campAdherentStaff);
        }
      });
      if (directors.length == 0 && this.currentCamp && !this.currentCamp._isCampEnfant) {
        this.warningMessageDirecteur = 'Vous devez avoir un directeur dans l\'équipe (cliquer sur le chef concerné pour le modifier)';
      }
      else {
        this.warningMessageDirecteur = '';
      }
    } else {
      this.warningMessageDirecteur = '';
    }
  }

  selectionnerDdcAdherentStaff(row: FormGroup) {
    const selectedAdherent: IAdherent = row.get('adherent') ? row.get('adherent').value : undefined;
    this.numeroAdherentSelectionne = selectedAdherent.numero ? parseInt(selectedAdherent.numero, 10) : undefined;
    this.ddcStaffSelectionneFormGroup = row;
    this.ddcStaffSelectionneFormGroup.markAllAsTouched();
  }

  supprimerDdcAdherentStaffSelectionne(row) {
    const staffsFormArray = this.getStaffsFormArray();
    const arrayIndex = staffsFormArray.controls.findIndex(staff => staff.value.adherent?.numero === row.value.adherent?.numero);
    staffsFormArray.removeAt(arrayIndex);
    this.initAdherentsDisponiblesTableData();
    this.initDdcStaffsTableData(staffsFormArray);
    this.ddcStaffSelectionneFormGroup = null;
    this.doUpdateAdherentsOptions.emit(this._compositionType);
  }

  setDdcAdherentStaffResp(event) {
    const controlNames: string[] = event && event.value ? event.value : '';
    if (controlNames) {
      this.ddcAdherentStaffResponsibilities.forEach(item => {
        if (controlNames.includes(item.value)) {
          this.ddcStaffSelectionneFormGroup.get(item.value).setValue(true);
        } else {
          this.ddcStaffSelectionneFormGroup.get(item.value).setValue(false);
        }
      });
    }
  }

  getDdcAdherentStaffResp() {
    let value = [];
    const controlNames = this.ddcAdherentStaffResponsibilities.map(item => item.value);
    controlNames.forEach(controlName => {
      if (this.ddcStaffSelectionneFormGroup.get(controlName).value === true) {
        value.push(controlName);
      }
    });
    return value;
  }

  setDdcAdherentStaffStage(event) {
    const controlName = event && event.value ? event.value : '';
    if (controlName !== '') {
      this.ddcStaffSelectionneFormGroup.get(controlName).setValue(true);
    }
    this.ddcAdherentStaffStages.filter(item => (item.value !== controlName && item.value !== '')).map(item => {
      this.ddcStaffSelectionneFormGroup.get(item.value).setValue(false);
    });
  }

  getDdcAdherentStaffStage() {
    let value = '';
    const controlNames = this.ddcAdherentStaffStages.filter(item => item.value !== '').map(item => item.value);
    controlNames.forEach(controlName => {
      if (this.ddcStaffSelectionneFormGroup.get(controlName).value === true) {
        value = controlName;
      }
    });
    return value;
  }

  getDdcAdherentStaffAvailableRoles() {
    if (this._typeDossier) {
      const ddcAdherentStaffRoles = this.ddcAdherentStaffRoles.filter(role => role.displayForTypeDossier.includes(this._typeDossier));
      if(this._currentCamp && this._currentCamp.typeCamp) {
        const campAdherentStaffRoles = ddcAdherentStaffRoles.filter(role =>
          role.displayForCampGroup.includes(this._currentCamp.typeCamp.codeGroupeCamp) &&
          (
            (
              this._currentCamp._isCampPere === false &&
              this._currentCamp._isCampEnfant === false &&
              role.displayForCampNormal === true
            ) ||
            (
              this._currentCamp._isCampPere === true &&
              role.displayForCampPere === true
            ) ||
            (
              this._currentCamp._isCampEnfant === true &&
              role.displayForCampEnfant == true
            )
          )
        );
        return campAdherentStaffRoles;
      }
      return ddcAdherentStaffRoles;
    }
  }

  getDdcStaffsTableDisplayedColumns(): string[] {
    if(this._typeDossier === TypeDossierEnum.CAMP) {
      if(this._currentCamp.codeGroupeCamp === TypeCampEnum.AUDACE) {
        return this.campAudaceStaffsTableDisplayedColumns;
      } else if (this._currentCamp.typeCamp.codeGroupeCamp === TypeCampGroupEnum.FARFADET) {
        return this.campFarfadetStaffsTableDisplayedColumns;
      }
      return this.campStaffsTableDisplayedColumns;
    } else {
      return this.projetAnneeStaffsTableDisplayedColumns;
    }
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1.code === o2.code;
  }

  structureDependanteCheckbox(isChecked){
    this.getAdherentsByStructure(this.structureSelected, isChecked);
  }

  displayStructureDependanteCheckbox(){
    return this.isStructureDependanteCheckbox = this.structureSelected['code'].substring(this.structureSelected['code'].length, this.structureSelected['code'].length - 2) == '00';
  }

  refreshAdherentsDisponiblesOptions() {
      this.initAdherentsDisponiblesTableData();
  }
}
